/** Skeleton rows. Sized to the table so the layout does not jump on load. */
export function LoadingState({ rows = 5 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-2 p-4" role="status" aria-busy="true">
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="bg-surface-sunken h-11 animate-pulse rounded-(--radius-control)"
        />
      ))}
    </div>
  );
}
